// isMobileUtils.ts
import { useMediaQuery } from "react-responsive"

export const useIsMobileHandler = (): boolean => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  return isMobile
}
